import React from 'react';
import Layout from '../components/Layout';
import {graphql} from 'gatsby';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import Nod from '../components/nod';

export default function Sastreria2024({data: {images}}) {

  return <Layout header={'SASTRERÍA DESESTRUCTURADA 2024'} next={"/sastreria/"}>
    <Nod title={'SASTRERÍA DESESTRUCTURADA 2024'}/>
    <div className="row project-gallery" id="fc-pics-container">
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[10])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[9])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[8])} alt="sastreria2024-image" />
      </div>
    </div>

    <div className="row project-gallery" id="fc-pics-container">
      <div className="col-xl-6 col-md-6 col-lg-6 col-sm-12 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[7])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-6 col-md-6 col-lg-6 col-sm-12 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[6])} alt="sastreria2024-image" />
      </div>
    </div>

    <div className="row project-gallery" id="fc-pics-container">
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[5])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[4])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[3])} alt="sastreria2024-image" />
      </div>
    </div>

    <div className="row project-gallery" id="fc-pics-container">
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[2])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[1])} alt="sastreria2024-image" />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
        <GatsbyImage image={getImage(images.nodes[0])} alt="sastreria2024-image" />
      </div>
    </div>
  </Layout>;
}

export const query = graphql`{
    images: allFile(
      filter: {relativePath: {regex: "/sd24_(.*)/i"}}
      sort: {order: DESC, fields: relativePath}
    ) { 
      nodes {
        id
        relativePath
        childImageSharp {
          gatsbyImageData(
            layout: CONSTRAINED
            quality: 100
          )
        }
        publicURL
      } 
    } 
  }
`;
